export const sectionConfig = {
    suptitle: "تیم فیگ ای آی",
    title: "ما کی هستیم؟",
    caption: "تیم «فیگ ای آی» از آدم‌هایی تشکیل شده که وسواسِ زیادی روی «تجربه کاربری» دارند. ما در این مسیر یاد گرفته‌ایم که بزرگترین سرمایه‌ی ما، اعتمادِ شماست. برای ما، اینکه یوزرها با خیالی راحت و بدون ترس از قطع شدن یا اتمامِ اشتراکِ ماهانه از پلتفرم استفاده کنند، بزرگترین دستاورد است.",
    caption2: "ما خودمان هم کاربرِ این ابزارها هستیم و می‌دانیم چقدر کلافه‌کننده است که ابزارتان وسطِ کار به خاطرِ پایانِ ماه، از دسترس خارج شود یا دیتایِ شما را محدود کند. ما اینجا هستیم تا این مدل‌هایِ پیچیده را برای شما ساده کنیم، به سرعتِ عملتان اضافه کنیم و در کنار هم، ابزاری بسازیم که در هر شرایطی، همراهِ هوشمندِ شما باشد.",
    final: "خوشحالیم که در این مسیر، شما همراهِ ما هستید."
}

export type SectionConfig = typeof sectionConfig
